import React from 'react';

interface TinkoffProps {
    width?: number;
    height?: number;
}

export const Tinkoff = ({ width = 36, height = 32 }: TinkoffProps) => (
    <svg
        width={width}
        height={height}
        viewBox="2 2 12.248 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 2H14.248V8.03527C14.248 9.58328 13.404 11.0137 12.04 11.7858L8.128 14L4.216 11.7858C2.844 11.0098 2 9.58328 2 8.03527V2Z"
            fill="#FFDD2D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.35999 5.17432V7.05152C5.61999 6.76151 6.09999 6.56556 6.64399 6.56556H7.23599V8.74845C7.23599 9.32846 7.07599 9.83794 6.83599 10.1162H9.41199C9.17199 9.83794 9.01199 9.32846 9.01199 8.74845V6.56556H9.60399C10.148 6.56556 10.624 6.76151 10.888 7.05152V5.17432H5.35999Z"
            fill="#333333"
        />
    </svg>
);
